import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../../core/animations';
import { Ticket } from '../../../../core/modelos/ticket';
import { TicketsService } from '../tickets.service';
import { User } from '../../../../core/modelos/user';
import { ContentService } from '../../content.service';
import { ActivosService } from '../../activos/activos.service';
import { Activo } from '../../../../core/modelos/activo';
import { NotificacionesService } from '../../../../core/notificaciones/notificaciones.service';
import { DocumentoTicket } from '../../../../core/modelos/documento_ticket';
import { FileManagerService } from '../../file-manager/file-manager.service';
import { CookieService } from 'ngx-cookie-service';
import { Location } from '@angular/common';

@Component({
    selector: 'fuse-tickets-editar',
    templateUrl: './tickets-editar.component.html',
    styleUrls: ['./tickets-editar.component.scss'],
    animations: fuseAnimations
})
export class TicketsEditarComponent implements OnInit {

    ticket: Ticket;
    idTicket: number;

    // Variable que indica si estamos editando o creando.
    editando = false;
    loading = true;

    // Validación del servidor
    validacion: any;

    // Formulario
    formulario: FormGroup;

    ocultar = true;

    usuarios: Array<User>;
    activos: Array<Activo>;

    selectedFiles: FileList;
    imagen;

    addAnexos = false; // Flag para el check
    idActivo: number; // Por si viene preseleccionado

    subiendoTicket = false;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private ticketsService: TicketsService,
        private contentService: ContentService,
        private activosService: ActivosService,
        private notificaciones: NotificacionesService,
        private fileManagerSrv: FileManagerService,
        private cookieService: CookieService,
        private location: Location
    ) {
        // Traigo el ticket por parametro
        this.activatedRoute.params.subscribe(params => {
            this.idTicket = +params['idTicket'];
            this.idActivo = +params['idActivo'];

            // notify about the new activo
            this.activosService.setCurrentActivo(this.idActivo)
        });
        // Tendre que traer usuarios para el solicitante y asignado y el listado de activos

    }

    ngOnInit() {
        this.init();
        this.getUsers();
        this.getActivos();
    }

    init() {
        if (this.idTicket) {
            this.editando = true;
            this.getTicket(this.idTicket); // TODO: Suscribir para redirigir si no existe

        } else {
            // console.log('añadiendo...');
            this.loading = false;
            this.crearFormulario();
        }
    }

    comprobarAnexos(){
        if (this.editando){
            this.addAnexos = !this.addAnexos;
        } else {
            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.NoPuedeVerAnexo);
        }
    }

    getTicket(id: number) {
        this.ticketsService.getTicket(id).subscribe(
            data => {
                if (data.success) {
                    this.ticket = data.items;
                    this.loading = false;
                    this.crearFormulario();
                    // Seteo el cliente del ticket
                    const usuarioLogueado: User = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
                    if (usuarioLogueado.rol.id === 1) {
                        this.fileManagerSrv.clienteBucket = JSON.parse(this.cookieService.get('clienteAdmin'));
                    }
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.TicketNOObtenido);
                    this.router.navigate(['tickets']);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    crearFormulario() {

        if (this.editando) {

            this.formulario = this.fb.group({

                titulo: [this.ticket.titulo, Validators.required],
                estado: [this.ticket.estado, Validators.required],
                // solicitante: [this.ticket.solicitante ? this.ticket.solicitante.nombre : null, Validators.required],
                activo: [this.ticket.activo ? this.ticket.activo : null, Validators.required],
                descripcion: [this.ticket.descripcion, Validators.required],
                prioridad: [this.ticket.prioridad, Validators.required],
                asignado: [this.ticket.asignado ? this.ticket.asignado : null, Validators.required],
                observaciones: [this.ticket.observaciones, Validators.required],
            });
        }
        else {

            this.formulario = this.fb.group({

                titulo: ['', Validators.required],
                estado: ['', Validators.required],
                // solicitante: ['', Validators.required],
                activo: ['', Validators.required],
                descripcion: ['', Validators.required],
                prioridad: ['', Validators.required],
                asignado: ['', Validators.required],
                observaciones: ['', Validators.required],
            });

        }

    }

    compare(val1, val2) {
        return val1.id === val2.id;
    }

    actualizarPag(event: boolean) {
        if (event) {
            this.init();
        }
    }

    onSubmit(): void {
        this.ticket = this.prepararModelo();
        if (this.editando) {
            this.ticketsService.updateTicket(this.ticket).subscribe(
                data => {
                    if (data.success) {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.TicketEditado);
                        // this.router.navigate(['tickets']);
                        this.init();
                        // TODO
                        // MENSAJE PARA EXPLICAR QUE AHORA PUEDE AÑADIR UN ADJUNTO
                    } else if (data.message) {
                        this.validacion = data.message;
                    }
                    else {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.TicketNOEditado);
                    }
                },
                err => {
                    this.notificaciones.errorServidor(err.status);
                }
            );

        } else {
            this.subiendoTicket = true;
            // Antes de dar de alta un ticket, voy a recoger la clave y la version del documento
            this.ticket.document_key = this.ticketsService.getKey();
            this.ticket.document_version = this.ticketsService.getVersion();
            this.ticketsService.addTicket(this.ticket).subscribe(
                data => {
                    if (data.success) {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.TicketCreado);
                        this.idTicket = data.items.id;
                        // Se manda email:
                        this.ticketsService.sendEmailTicket(this.idTicket).subscribe();
                        this.init();
                        // this.router.navigate(['tickets']);
                        // TODO
                        // MENSAJE PARA EXPLICAR QUE AHORA PUEDE AÑADIR UN ADJUNTO
                    } else if (data.message) {
                        this.validacion = data.message;
                    }
                    else {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.TicketNOCreado);
                    }
                },
                err => {
                    this.notificaciones.errorServidor(err.status);
                    // if (err.error.message) {
                    //     this.validacion = err.error.message;
                    // }
                },
                () => this.subiendoTicket = false
            );
        }

    }

    prepararModelo(): Ticket {
        const formModel = this.formulario.value;

        const saveTicket: Ticket = {
            id: this.ticket ? this.ticket.id : undefined,
            titulo: formModel.titulo,
            estado: formModel.estado,
            solicitante: formModel.solicitante,
            activo: formModel.activo,
            descripcion: formModel.descripcion,
            prioridad: formModel.prioridad,
            asignado: formModel.asignado,
            observaciones: formModel.observaciones
        };

        return saveTicket;
    }

    getUsers() {
        this.contentService.getUsers().subscribe(
            data => {
                if (data.success) {
                    this.usuarios = data.items;
                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.Usuarios.SinUsuarios);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );
    }
    getActivos() {
        this.activosService.getActivosDatosBasicos().subscribe(
            data => {
                if (data.success) {
                    this.activos = data.items;
                    if (this.idActivo) {
                        this.activos.forEach(activo => {
                            if (activo.id === this.idActivo) {
                                this.formulario.controls['activo'].setValue(activo);
                            }
                        });
                    }
                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.Activos.SinActivos);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    selectFile(event) {
        if (this.editando) {
            // Solo puedo añadir anexos con el ticket creado
            this.selectedFiles = event.target.files;
            const file = this.selectedFiles.item(0);
            const component = this;
            // console.log(file);
            const anexo: DocumentoTicket = new DocumentoTicket();
            anexo.nombre_logico = file.name;

            const timestamp = new Date().getTime().toString();
            const name = this.fileManagerSrv.carpetaOculta + '/' + timestamp + file.name;
            anexo.nombre_fisico = name;
            anexo.incidencia_id = this.idTicket * 1;
            // FALTARIA INTENTAR CONTROLAR QUE EL USUARIO NO SUBA UN ARCHIVO CUYO NOMBRE CONTENGA "/"
            this.fileManagerSrv.uploadAnexoTicket(file, name).send(function (err) {
                if (!err) {
                    component.ticketsService.insertAnexo(anexo).subscribe(
                        res => {
                            if (res.success) {
                                // TODO FEEDBACK
                                // alert ('anexo añadido');
                                component.notificaciones.mostrarAviso(component.notificaciones.mensajes.IdiomaActual.Tickets.AnexoAdded);
                                component.getTicket(component.idTicket);
                            } else {
                                // TODO CONTROLAR ERROR
                            }
                        },
                        error => {
                            this.notificaciones.errorServidor(error.status);
                        }
                    );
                } else {
                    // TODO CONTROL ERROR
                }
            });
            event.target.files = null;
        } else {
            // TODO
            // PRIMERO DEBES CREAR EL TICKET
        }
    }
    anexoBorrado(event){
        if (event){
            this.init();
        }
    }

    goBack() {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/tickets/editar/tickets-editar.component.ts